import { useMemo } from 'react'

import { useLoginService } from 'features/account/hooks'
import { NotificationScope } from 'features/notifications/types/grouped'

/**
 * The selected role and communities the bell, notifications page and Updates feed are scoped
 * to — the same values the referral list and referral detail send.
 * @returns a memoised scope that changes only when the role or community selection does.
 */
export const useNotificationScope = (): NotificationScope => {
  const { getSelectedRoleLevel, getSelectedFacilities } = useLoginService()

  return useMemo(
    () => ({
      userLevel: getSelectedRoleLevel,
      applicableCommunityList: getSelectedRoleLevel === 2 ? getSelectedFacilities : [],
    }),
    [getSelectedRoleLevel, getSelectedFacilities],
  )
}
